interface BookCoverProps {
  title: string;
  subtitle?: string | null;
  author?: string | null;
  image?: string | null;
  className?: string;
}

/**
 * Renders a book cover. When the admin uploads a real cover image it is shown;
 * otherwise a designed typographic cover is used so no generated image is needed.
 */
export default function BookCover({ title, subtitle, author, image, className = '' }: BookCoverProps) {
  if (image && image.trim()) {
    return (
      <img
        src={image}
        alt={`${title} book cover`}
        className={`w-full h-full object-cover object-top ${className}`}
      />
    );
  }

  return (
    <div className={`relative w-full h-full flex flex-col justify-between overflow-hidden bg-gradient-to-br from-foreground-900 via-foreground-950 to-primary-900 p-5 ${className}`}>
      <div className="absolute inset-y-0 left-0 w-2 bg-accent-500" />
      <div className="relative">
        <p className="text-[10px] font-label uppercase tracking-[0.25em] text-accent-400 mb-3">TGMCI Publications</p>
        <h3 className="font-heading font-bold text-white leading-snug text-lg">{title}</h3>
        {subtitle && <p className="text-white/60 text-xs mt-3 leading-relaxed line-clamp-3">{subtitle}</p>}
      </div>
      <div className="relative">
        <div className="w-8 h-0.5 bg-accent-500 mb-2" />
        <p className="text-xs font-label text-white/80 uppercase tracking-widest">{author || 'Apostle A. C. Oliver'}</p>
      </div>
      <div className="absolute -right-8 -bottom-8 w-28 h-28 rounded-full bg-accent-500/10" />
    </div>
  );
}